import React, { Component } from 'react';
import moment from 'moment';
import { CURRENCY } from '../libs/utils/Const';
import ApiClient from '../libs/apiClient';
import $ from 'jquery';
import '../css/responsive.css';
const apiClient = ApiClient.getInstance();
//formato de cantidades
var formatNumber = {
    separador: ",", // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        var splitStr = num.split('.');
        var splitLeft = splitStr[0];
        var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        var regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    }
}

// Tabla de documentos
const renderTableBody = (headers, data, checkbox, openDocumentDetails) => {
    let body = "";

    body = data.map((register, index) => {

        let docDate = new Date(register.DocDate);
        let docDueDate = new Date(register.DocDueDate);

        docDate.setMinutes(docDate.getMinutes() + docDate.getTimezoneOffset());
        docDueDate.setMinutes(docDueDate.getMinutes() + docDueDate.getTimezoneOffset());

        return (
            <tr key={index}>
                <td className="sticky-column">
                    <input 
                        type="checkbox" 
                        style={{minWidth: '100%'}} 
                        id="cbox2"
                        checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)}/>
                </td>
                {headers[0].value && <td>{register.SeriesName}</td>}
                {headers[9].value && <td className="text-center" style={{color: register.DocStatus === 'C' ? 'red' : 'black'}}>{register.DocStatus === 'O' ? "Abierto" : "Cerrado"}</td>}
                {headers[1].value && <td className="text-right font-weight-bold">{register.DocNum}</td>}
                {headers[2].value && <td>{register.CardCode}</td>}
                {headers[3].value && <td className="text-center align-middle text-break">{register.SuppName}</td>}
                {headers[4].value && <td>{register.AgentCode || ''}</td>}
                {headers[5].value && <td className="text-center align-middle text-break">{register.AgentName}</td>}
                {headers[6].value && <td className="text-center">{moment(docDate).format("DD-MM-YYYY")}</td>}
                {headers[7].value && <td className="align-middle text-break">{register.Descr || "No hay comentarios"}</td>}
                {headers[8].value && <td className="text-right font-weight-bold">{CURRENCY+formatNumber.new(Number(register.DocTotal) === 0 || register.DocTotal <= '0' || register.DocTotal === null || register.DocTotal === NaN || register.DocTotal === 'undefined' || register.DocTotal === undefined || register.DocTotal === "" ? "0.00" : register.DocTotal)}</td>}
                <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>
                    <button 
                        type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                        onClick={() => openDocumentDetails({DocEntry: register.DocEntry, index})}
                        style={{fontWeight: '500'}}
                    >
                        <i className="far fa-file-alt"></i> 
                        Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};

const renderTable = (headers, data, checkbox, openDocumentDetails) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-column" style={{backgroundColor: "#e9ecef"}}>
                <input 
                    type="checkbox" 
                    style={{minWidth: '100%'}} 
                    id="cbox2" value="second_checkbox"
                    onChange={(event) => checkbox.selectAll(event.target.checked)}
                />
            </td>

            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[9].title}</td>}
            {headers[2].value && <td>{headers[1].title}</td>}
            {headers[3].value && <td>{headers[2].title}</td>}
            {headers[4].value && <td>{headers[3].title}</td>}
            {headers[5].value && <td>{headers[4].title}</td>}
            {headers[6].value && <td>{headers[5].title}</td>}
            {headers[7].value && <td>{headers[6].title}</td>}
            {headers[8].value && <td>{headers[7].title}</td>}
            {headers[9].value && <td>{headers[8].title}</td>}

            <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>Acciones</td>
        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDocumentDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{width: '100%'}}>
        <thead className="table-header">
        {header}
        </thead>
        <tbody>
        {body}
        </tbody>
    </table>;

    return table;
};

export const renderTableLandedCosts = (headers, data, checkbox, openDocumentDetails) => {

    return renderTable(headers, data, checkbox, openDocumentDetails);
}

const headersBody = [
    { title: "Artículo", value: true },
    { title: "Descripción", value: true, style:{ minWidth: 200 }},
    { title: "Cantidad", value: true },
    { title: "P. Doc. Base", value: true},
    { title: "V. Doc. Base", value: true },
    { title: "Aduana Prevista", value: true },
    { title: "V. Aduana", value: true },
    { title: "Gastos", value: true },
    { title: "V. Costos Imput.", value: true },
    { title: "P. Almacén", value: false },
    { title: "Total", value: false },
    { title: "Costos Totales", value: false },
    { title: "Almacén", value: true },
];

const headersCosts = [
    { title: "P. de Entrega", value: true, style: {width: '250px'}},
    { title: "Imput. por", value: true, style: {width: '300px'}},
    { title: "Importe", value: true },
    { title: "Factor", value: false },
    { title: "Incl. p/ aranceles aduaneros", value: true },
];

const imputationFor = [
    {value: 'A', title: 'Igual a'},
    {value: 'Q', title: 'Cantidad'},
    {value: 'V', title: 'Volumen'},
    {value: 'W', title: 'Peso'},
    {value: 'F', title: 'Valor monetario incluidos los derechos de importación'},
    {value: 'C', title: 'Valor monetario excluidos los derechos de importación'},              
];

class ContentLandedCosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deliveryPrices: [],
        };
    }

    componentDidMount = async () => {
        await this.getDeliveryPrices();
    }

    getDeliveryPrices = async () => {
        const { enableSpinner, newOrderModel, refreshModel , action } =  this.props; 
        if(action === 1){
            enableSpinner(true);
            const deliveryPrices = await apiClient.getRecordsTable('OALC');
            newOrderModel.landedCosts.deliveryPrices = deliveryPrices.data || [];
            enableSpinner(false);
            refreshModel(newOrderModel);
        }
    }

    renderHeader = () => {    
        const { newOrderModel, action, openPartner, changeCardCode, openCurrency, selectDocDate, selectDocDueDate } = this.props;
        const { landedCosts, partnerSelected, CardCode, CardName, DocCur, ChangeRate, SerieName, NextFolio, StatusDocument, DocDate, DocDueDate } =  newOrderModel;
        const { AgentSelected, AgentCode, AgentName } = newOrderModel;
        const { Ref1, AgentNum } = landedCosts;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*proveedor*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Proveedor</span>
                        </div>
                        <input type="text" className="form-control" id="txtPartner" autocomplete="on"
                            style={{ backgroundColor: partnerSelected ? 'rgb(248,242,209)' : 'transparent', }}
                            disabled={action === 2}
                            onKeyPress={(ev) => {
                                if (ev.key === 'Enter') {
                                    openPartner();
                                }
                            }}
                            onChange={(e)=> changeCardCode(e)}
                            value={CardCode || ''} />
                        {action === 1 && (
                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={()=> openPartner()}>
                                <i className="fas fa-user fa-lg" />
                            </button>
                        )}
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtCardName"
                            disabled="true"
                            value={CardName || ''}
                        />
                    </div>
    
                    {/*FLETERO */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fletero</span>
                        </div>
                        <input type="text" className="form-control" id="txtAgentCode" name="AgentCode" autocomplete="on"
                            style={{ backgroundColor: AgentSelected ? 'rgb(248,242,209)' : 'transparent', }}
                            disabled={action === 2}
                            onKeyPress={(ev) => {
                                if (ev.key === 'Enter') {
                                    openPartner(null, true);
                                }
                            }}
                            onChange={(e)=> changeCardCode(e)}
                            value={AgentCode || ''} />
                        {action === 1 && (
                            <button type="button" className="input-group-text" style={{ backgroundColor: 'transparent', color: '#EABF28' }} onClick={()=> openPartner(null, true)}>
                                <i className="fas fa-user fa-lg" />
                            </button>
                        )}                       
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtAgentName"
                            disabled="true"
                            value={AgentName ||''}
                        />
                    </div>
                
                    {/*Moneda */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Moneda</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={DocCur || ''}
                        />
                        {(action === 1) && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={()=> openCurrency()}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
    
                    {/*Moneda */}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cambio</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtLocalCurrency"
                            disabled={true}
                            value={ChangeRate || 1}
                        />
                    </div> */}
    
                    {/*No Serie*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input
                            type="text"
                            className=" form-control"
                            id="txtDocumentDate"
                            disabled="true"
                            value={SerieName || ''}
                        />
                        {action === 1 && (
                            <button
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={this.props.openSeries}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                </div>
    
                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    {/*N°:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">N°</span>
                        </div>
                        <input
                            type=" text"
                            className=" form-control"
                            id="txtNo"
                            disabled="true"
                            value={NextFolio || ''}
                        />
                    </div>
    
                    {/*Fecha de contabilización:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Contabilización</span>
                        </div>
                        <input
                            id="txtPostingDate"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control"
                            type="date"
                            disabled={action === 2}
                            autoComplete="off"
                            value={DocDate || ''}
                            onChange={(e)=> selectDocDate(e)}
                        />
                    </div>
    
                    {/*Fecha de vencimiento:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Vencimiento</span>
                        </div>
                        <input
                            id="txtFVenci"
                            style={{
                                width: '100%',
                                important: true,
                                backgroundColor: 'transparent',
                                borderColor: '#ced4da',
                                color: '#000',
                            }}
                            className="form-control"
                            type="date"
                            disabled={action === 2}
                            autoComplete="off"
                            value={DocDueDate || ''}
                            onChange={(e)=> selectDocDueDate(e)}
                        />
                    </div>
                    
                    {/*Folio Fisico*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Fisico Entrada</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtRef1"
                            autoComplete="off"
                            name="Ref1"
                            disabled={action === 2}
                            onChange={this.onChangeInputs}
                            value={Ref1 || ''}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">F. Fisico Flete</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtAgentNum"
                            autoComplete="off"
                            name="AgentNum"
                            disabled={action === 2}
                            onChange={this.onChangeInputs}
                            value={AgentNum || ''}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderBody = () => {
        const { newOrderModel, validatePartner, action } = this.props;
        const { landedCosts: { deliveryPrices }, DocCur } = newOrderModel; 
        const newOrderModelItems = newOrderModel.Items.length > 0 ? newOrderModel.Items : [];

        return (
            <div style={{ marginBottom: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary"
                            id="nav-profile-tab-Costs-D"
                            data-toggle="tab"
                            href="#dataCostsDocument"
                            role="tab"
                            aria-controls="dataCostsDocument"
                            aria-selected="true">
                            Costos
                        </a>
                    </div>
                </nav>

                <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                    {/* CONTENIDO */}
                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }}
                    >
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center"}}>
                                    <td className="sticky-column sticky-header" style={{ width: 40, background: "#d2ab24" }}>
                                        #
                                    </td>
                                    {headersBody.map((header, index) => {
                                        if (header.value) {
                                            return (
                                                <td key={index} className="sticky-header" style={{ ...header.style, background: "#d2ab24" }}>
                                                    {header.title}
                                                </td>    
                                            );
                                        } 
                                    })}                                     
                                </tr>
                            </thead>
                            <tbody>
                                {newOrderModelItems.map((item, index) => {
                                    const { ItemCode, Dscription, Quantity, PriceFOB, FobValue, Custom,TtlCustLC } = item;
                                    const { Cost, TtlExpndLC, PriceAtWH, LineTotal, TtlCostLC, Currency, WhsCode } = item;
                                    const formatCurrency = (value) => `${formatNumber.new(value)} ${Currency}`;
                                    const formatView = (value) => action === 2 ? `${formatNumber.new(value)}` : value;
                                    const changeCase = 'lines';

                                    return (
                                        <tr key={index + ItemCode} style={{ maxHeight: 10, paddingTop: 8, paddingBottom: 8, background: "#FFF", textAlign: 'right' }}>
                                            <td className="sticky-column text-center align-middle" style={{  width: 40, background: "#FFF" }}>
                                                {index + 1}
                                            </td>
                                            <td className="overflow-visible text-center align-middle">
                                                {ItemCode}
                                            </td>
                                            <td className="overflow-visible align-middle text-left" style={{ minWidth:200 }}>
                                                {Dscription}
                                            </td>
                                            <td className="text-nowrap align-middle">
                                                {Math.round(Quantity)}
                                            </td>
                                            <td className="text-nowrap align-middle">
                                                {formatCurrency(PriceFOB)}
                                            </td>
                                            <td className="text-nowrap align-middle">
                                                {formatCurrency(FobValue)}
                                            </td>

                                            {headersBody[5].value &&
                                                <td className="text-nowrap align-middle">
                                                   <div className="position-relative d-inline-block">
                                                       <input
                                                           style={{ textAlign: 'right', width: '150px', paddingRight: '40px' }}
                                                           type="text"
                                                           className="form-control"
                                                           id="txtCustom"
                                                           name="Custom"
                                                           onChange={(e) => this.onChangeInputs(e, changeCase, index)}
                                                           onBlur={(e) => this.handleChangeNum(e, changeCase, index)}
                                                           disabled={true}
                                                           value={formatView(Custom)}
                                                       />
                                                       {this.renderCurrencyLines(`${index}-Custom`, Currency)}
                                                   </div>
                                               </td>
                                            }

                                            {headersBody[6].value &&
                                                <td className="text-nowrap align-middle">
                                                   <div className="position-relative d-inline-block">
                                                       <input
                                                           style={{ textAlign: 'right', width: '150px', paddingRight: '40px' }}
                                                           type="text"
                                                           className="form-control"
                                                           id="txtTtlCustLC"
                                                           name="TtlCustLC"
                                                           onChange={(e)=> this.onChangeInputs(e, changeCase, index)}
                                                           onBlur={(e) => this.handleChangeNum(e, changeCase, index)}
                                                           disabled={true}
                                                           value={formatView(TtlCustLC)}
                                                       />
                                                       {this.renderCurrencyLines(`${index}-TtlCustLC`, Currency)}
                                                   </div>
                                               </td>
                                            }

                                            <td className="text-nowrap align-middle">
                                                <div className="position-relative d-inline-block">
                                                    <input
                                                        style={{ textAlign: 'right', width: '150px', paddingRight: '40px' }}
                                                        type="text"
                                                        className="form-control"
                                                        id="txtCost"
                                                        name="Cost"
                                                        onChange={(e)=> this.onChangeInputs(e, changeCase, index)}
                                                        onBlur={(e) => this.handleChangeNum(e, changeCase, index)}
                                                        disabled={true}
                                                        value={formatView(Cost)}
                                                    />
                                                    {this.renderCurrencyLines(`${index}-Cost`, Currency)}
                                                </div>
                                            </td>
                                            <td className="text-nowrap align-middle">
                                                <div className="position-relative d-inline-block">
                                                    <input
                                                        style={{ textAlign: 'right', width: '150px', paddingRight: '40px' }}
                                                        type="text"
                                                        className="form-control"
                                                        id="txtTtlExpndLC"
                                                        name="TtlExpndLC"
                                                        onChange={(e)=> this.onChangeInputs(e, changeCase, index)}
                                                        onBlur={(e) => this.handleChangeNum(e, changeCase, index)}
                                                        disabled={true}
                                                        value={formatView(TtlExpndLC)}
                                                    />
                                                    {this.renderCurrencyLines(`${index}-TtlExpndLC`, Currency)}
                                                </div>
                                            </td>

                                            {headersBody[9].value &&
                                                <td className="text-nowrap align-middle">
                                                    {formatCurrency(PriceAtWH)}
                                                </td>
                                            }

                                            {headersBody[10].value &&
                                                <td className="text-nowrap align-middle">
                                                    {formatCurrency(LineTotal)}
                                                </td>
                                            }

                                            {headersBody[11].value &&
                                                <td className="text-nowrap align-middle">
                                                    {formatCurrency(TtlCostLC)}
                                                </td>
                                            }
                                            
                                            <td className="align-middle">
                                                {WhsCode}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* COSTOS */}
                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataCostsDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Costs"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }}
                    >
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center"}}>
                                    <td className="sticky-column sticky-header" style={{ width: '40px', background: "#d2ab24" }}>
                                        #
                                    </td>
                                    {headersCosts.map((header, index) => {
                                        if(header.value){
                                            return (
                                                <td key={index} className="sticky-header" style={{ ...header.style, background: "#d2ab24" }}>
                                                    {header.title}
                                                </td> 
                                            )  
                                        } 
                                    })}
                                </tr>   
                            </thead>
                            <tbody>
                                {deliveryPrices.map((price, index) => {
                                    const { AlcCode, AlcName, CostSum, InCustCalc, OhType} = price
                                    const changeCase = 'costLines';
                                    const formatView = (value) => action === 2 ? `${formatNumber.new(value)}` : value;

                                    return (
                                        <tr key={AlcCode}  style={{ maxHeight: 10, paddingTop: 8, paddingBottom: 8,  background: "#FFF"}}>
                                            <td className="sticky-column text-center align-middle" style={{ width: '40px' }}>
                                                {index + 1}
                                            </td>
                                            <td className="overflow-visible align-middle">
                                                {AlcName}
                                            </td> 
                                            <td className="overflow-visible align-middle">
                                                <select
                                                    className="form-control"
                                                    name="OhType"
                                                    value={OhType}
                                                    disabled={action === 2}
                                                    onChange={(e)=> this.onChangeInputs(e, '', index)}
                                                >
                                                    {imputationFor.map((input, index) => {
                                                        return (
                                                            <option key={index} value={input.value}>{input.title}</option>                                                             
                                                        )   
                                                    })}
                                                </select>
                                            </td>

                                            <td className="text-nowrap align-middle">
                                                <div className="position-relative d-inline-block">
                                                    <input
                                                        style={{ textAlign: 'right', width: '150px', paddingRight: '40px' }}
                                                        type="text"
                                                        className="form-control"
                                                        id="txtCostSum"
                                                        name="CostSum"
                                                        onChange={(e) => this.onChangeInputs(e, changeCase, index)}
                                                        onBlur={(e) => this.handleChangeNum(e, changeCase, index, AlcCode)}
                                                        disabled={action === 2}
                                                        value={formatView(CostSum)}
                                                    />
                                                    {this.renderCurrencyLines(`${index}-CostSum`, DocCur)}
                                                </div>
                                            </td>

                                            {headersCosts[3].value &&
                                                <td className="overflow-visible align-middle"></td>
                                            }

                                            <td className="align-middle text-center">
                                                <input 
                                                    type="checkbox" 
                                                    aria-label="Checkbox for following text input"
                                                    name="InCustCalc"
                                                    disabled={action === 2} 
                                                    onChange={(e)=> this.onChangeInputs(e, '', index)}
                                                    checked={InCustCalc}
                                                />&nbsp;
                                            </td>    
                                        </tr>
                                    )})
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    renderFooter = () => {
        const { newOrderModel, action, changeComments } = this.props;
        const { landedCosts, Comments, DocTotal, DocCur } = newOrderModel;
        const { CustDate, IncCustom, ExpCustom, ActCustom, CostSum, BeforeVat, Vat1, Vat2 } = landedCosts;
        const formatView = (value) => action === 2 ? `${formatNumber.new(value)}` : value;

        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    {/*Aduanas Previstas*/}
                    {/* <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Aduanas previstas</span>
                        </div>
                        <input
                            style={{ width: '54%', textAlign: 'right' }}
                            type="text"
                            className="form-control position-relative"
                            id="txtExpCustom"
                            disabled={true}
                            placeholder='0.00'
                            value={ExpCustom || ''}
                        />
                        {this.renderCurrency(0)}
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Impto. aduana reales</span>
                        </div>
                        <input
                            style={{width: '48%', textAlign: 'right'}}
                            type="text"
                            className="form-control"
                            id="txtActCustom"
                            name="ActCustom"
                            placeholder='0.00'
                            disabled={true}
                            value={ActCustom || ''}
                        />
                        {this.renderCurrency(1)}
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha de aduana</span>
                        </div>
                        <input
                            type="date"
                            className="form-control"
                            id="txtCustDate"
                            name="CustDate"
                            disabled={action === 2}
                            onChange={this.onChangeInputs}
                            value={CustDate}
                        />
                    </div> */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <div className="input-group-text">
                                <input 
                                    type="checkbox" 
                                    id="chkIncCustom" 
                                    name="IncCustom"
                                    aria-label="Checkbox for following text input"
                                    disabled={action === 2} 
                                    onChange={this.onChangeInputs}
                                    checked={IncCustom}
                                />&nbsp;
                                <span className="font-weight-bold" id="basic-addon1">Aduana afecta a inventario</span>
                            </div>
                        </div>
                    </div>

                    {/*Comentarios:*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                            type="text"
                            className="form-control styleTextarea"
                            id="txtComments"
                            name="Comments"
                            placeholder="250 caracteres máximo"
                            maxLength={250}
                            onChange={(e)=> changeComments(e)}
                            disabled={action === 2}
                            value={Comments || ''}
                        />
                    </div>
                </div>

                {/*Segunda columna*/}
                {/* <div className="col-sm" style={{ paddingRight: 0 }}>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1" style={{width: '100%'}}>Gastos totales de transporte</span>
                        </div>
                        <input
                            style={{width: '74%', textAlign: 'right'}}
                            type="text"
                            className="form-control"
                            id="txtCostSum"
                            placeholder='0.00'
                            disabled="true"
                            value={CostSum || ''}
                        />
                        {this.renderCurrency(2)}
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1" style={{width: '100%'}}>Monto a saldar</span>
                        </div>
                        <input
                            style={{width: '74%', textAlign: 'right'}}
                            type="text"
                            className="form-control"
                            id=""
                            disabled="true"
                            placeholder='0.00'
                            value={''}
                        />
                        {this.renderCurrency(3)}
                    </div>
                </div> */}

                {/*Tercera columna*/}
                <div className="col-12 col-md-6" style={{ paddingRight: 0 }}>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1" style={{ width: '100%' }}>
                                <span className="d-none d-xxl-inline"> Antes de Impuestos</span>
                                <span className="d-inline d-xxl-none">Ant. Imp</span>
                            </span>
                        </div>
                        <input
                            style={{width: '74%', textAlign: 'right'}}
                            type="text"
                            className="form-control groupresponsive"
                            id="txtBeforeVat"
                            disabled="true"
                            value={formatNumber.new(BeforeVat)}
                        />
                        {this.renderCurrency(4)}
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1" style={{width: '100%'}}>Impuesto 1</span>
                        </div>
                        <input
                            style={{width: '80%', textAlign: 'right'}}
                            type="text"
                            className="form-control groupresponsive"
                            id="txtVat1"
                            name="Vat1"
                            onChange={(e)=> this.onChangeInputs(e, 'taxes')}
                            onBlur={(e)=> this.handleChangeNum(e, 'taxes')}
                            disabled={action === 2}
                            value={formatView(Vat1)}  
                        />
                        {this.renderCurrency(5)}
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1" style={{width: '100%'}}>Impuesto 2</span>
                        </div>
                        <input
                            style={{width: '80%', textAlign: 'right'}}
                            type="text"
                            className="form-control groupresponsive"
                            id="txtVat2"
                            name="Vat2"
                            onChange={(e)=> this.onChangeInputs(e, 'taxes')}
                            onBlur={(e)=> this.handleChangeNum(e, 'taxes')}
                            disabled={action === 2}
                            value={formatView(Vat2)}
                        />
                        {this.renderCurrency(6)}
                    </div>

                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Total</span>
                        </div>
                        <input
                            style={{width: '56%', textAlign: 'right'}}
                            type="text"
                            className="form-control groupresponsive"
                            id="txtDocTotal"
                            placeholder="0.00"
                            disabled="true"
                            value={formatNumber.new(DocTotal)}
                        />
                        {this.renderCurrency(7)}
                    </div>
                </div>
            </div>
        );
    }

    onChangeInputs = (e, changeCase = null, index = null) => {
        const { refreshModel, newOrderModel } = this.props;
        const { name, value, checked, type } = e.target;
    
        const isNumericField = ['lines', 'taxes', 'costLines'].includes(changeCase) || ['CostSum', 'ActCustom', 'Vat1', 'Vat2'].includes(name);
        if (isNumericField && isNaN(value)) {
            return;
        }
    
        switch (changeCase) {
            case 'lines':
                newOrderModel.Items[index][name] = value;
                break;
            case 'taxes':
                newOrderModel.landedCosts[name] = value;
                break;
            case 'costLines':
                newOrderModel.landedCosts.deliveryPrices[index][name] = value;
                break;
            default:
                if (type === 'checkbox') {
                    if (name === 'InCustCalc') {
                        newOrderModel.landedCosts.deliveryPrices[index][name] = checked;
                    } else {
                        newOrderModel.landedCosts[name] = checked;
                    }
                } else {
                    if (name === 'OhType') {
                        newOrderModel.landedCosts.deliveryPrices[index][name] = value;
                    } else {
                        newOrderModel.landedCosts[name] = value;
                    }
                }
                break;
        }
    
        refreshModel(newOrderModel);
    }
    
    handleChangeNum = async (e, changeCase = null, index = null, id = null) => {
        const { newOrderModel, refreshModel } = this.props;
        let { name, value } = e.target;
        value = parseFloat(value) || 0;
    
        const updateValue = (obj, key, newValue, prevValue) => {
            obj[key] = formatNumber.new(newValue);
            newOrderModel.DocTotal += newValue - prevValue;
        };

        const findAndUpdatePrevValues = (key, id, value) => { 
            let exist = newOrderModel.landedCosts.prevValues.find(val => val[key] === id);
            let prev = exist ? exist.value : 0;
            if (exist) {
                exist.value = value;
            } else {
                newOrderModel.landedCosts.prevValues.push({ [key]: id, value });
            }
            return prev;
        };
    
        switch (changeCase) {
            case 'lines':
                newOrderModel.Items[index][name] = formatNumber.new(value);
                break;
            case 'taxes':
                let prev = findAndUpdatePrevValues('name', name, value);
                updateValue(newOrderModel.landedCosts, name, value, prev);
                break;
            case 'costLines':
                let prevCost = findAndUpdatePrevValues('AlcCode', id, value);
                updateValue(newOrderModel.landedCosts.deliveryPrices[index], name, value, prevCost);
                newOrderModel.landedCosts.BeforeVat += value - prevCost;
                break;
            default:
                break;
        }
    
        refreshModel(newOrderModel);
    };

    renderCurrencyLines = (index, Currency) => {
        return (
            <span key={index} className="position-absolute" style={{ right: '5px', top: '49%', transform: 'translateY(-50%)', pointerEvents: 'none' }}>
                {Currency}
            </span>
        );
    }

    renderCurrency = (index) => {
        const { newOrderModel, action} = this.props;
        const inputsToCheck = [5, 6];
        const style = { backgroundColor: action === 1 && inputsToCheck.includes(index) ? '#FFF' : '#e9ecef'};

        return (
            <div key={index} className="input-group-append">
                <span className="input-group-text" style={style}>{newOrderModel.DocCur || ''}</span>
            </div>
        );
    }

    selectDocType = (table) => {
        let subject = '',  objType = '';
        switch(table){
            case'OIPF':
                subject = 'Precio de entrega';
                objType = 69;
            break;
            case'OPDN':
                subject = 'Pedido de entrada de mercancías';
                objType = 20;
            break;
            case'OPCH':
                subject = 'Fact.proveedores';
                objType = 18;
            break;
        }

        return {subject, objType};
    }

    selectOfDocuments = async (documentsSelected) => {
        const { newOrderModel, selectOfReference, refreshModel } = this.props;
        const table = documentsSelected[0]?.table || '';
        const origin = this.selectDocType(table)?.subject || '';
        let comments = origin ? `Basado en ${origin}` : '';
    
        newOrderModel.isSelectOfActive = true;
    
        documentsSelected.forEach(document => {
            const { header, items, lines2 = [] } = document;
            const info = { table, DocEntry: header.DocEntry };
    
            if (table === 'OIPF') {
                const vat1 = parseFloat(header.Vat1);
                const vat2 = parseFloat(header.Vat2);
                newOrderModel.AgentCode = header.AgentCode || '';
                newOrderModel.AgentName = header.AgentName || '';
                newOrderModel.DocTotal = vat1 + vat1;
                newOrderModel.landedCosts.Vat1 = formatNumber.new(vat1);
                newOrderModel.landedCosts.Vat2 = formatNumber.new(vat2);
                newOrderModel.landedCosts.prevValues.push(
                    { name: 'Vat1', value: newOrderModel.landedCosts.Vat1 },
                    { name: 'Vat2', value: newOrderModel.landedCosts.Vat2 }
                );
            }
    
            this.setItems(items, info);
            this.setLines2(lines2, info);
    
            if (header?.DocNum) {
                comments += ` ${header.DocNum},`;
            }
        });
    
        newOrderModel.Comments = comments;
    
        refreshModel(newOrderModel);
    
        if (selectOfReference) {
            selectOfReference.disableDataTable();
        }
    
        $('#selectOfModal').modal('hide');
    };
    
    setItems = (items, info) => {
        const { newOrderModel } = this.props;
        const { table, DocEntry } = info;
    
        items.forEach(item => {
            const LineTotal = parseFloat(item.LineTotal);
    
            newOrderModel.Items.push({
                ItemCode: item.ItemCode,
                Dscription: item.Dscription,
                Quantity: item.Quantity,
                PriceFOB: table === 'OIPF' ? item.PriceFOB : item.Price,
                FobValue: table === 'OIPF' ? item.FobValue : LineTotal,
                Custom: table === 'OIPF' ? formatNumber.new(item.Custom) : 0,
                TtlCustLC: table === 'OIPF' ? formatNumber.new(item.TtlCustLC) : 0,
                Cost: table === 'OIPF' ? formatNumber.new(item.Cost) : 0,
                TtlExpndLC: table === 'OIPF' ? formatNumber.new(item.TtlExpndLC) : 0,
                PriceAtWH: item.PriceAtWH || item.Price,
                TtlCostLC: table === 'OIPF' ? item.TtlCostLC : 0,
                LineTotal,
                WhsCode: item.WhsCode,
                Currency: item.Currency,
                BaseEntry: DocEntry,
                BaseType: this.selectDocType(table).objType,
                BaseLine: item.LineNum,
            });
    
            newOrderModel.landedCosts.BeforeVat += LineTotal;
            newOrderModel.DocTotal += LineTotal;
        });
    };
    

    setLines2 = (lines2, info) => {
        const { newOrderModel } = this.props;
        const { table } = info;
    
        if (table === 'OIPF') {
            newOrderModel.landedCosts.deliveryPrices.forEach(deliveryPrice => {
                lines2.forEach(line => {
                    if (deliveryPrice.AlcCode === line.AlcCode) {
                        newOrderModel.landedCosts.prevValues.push({AlcCode: deliveryPrice.AlcCode, value: line.CostSum});
                        deliveryPrice.CostSum = formatNumber.new(line.CostSum);
                        deliveryPrice.OhType = line.OhType;
                        deliveryPrice.InCustCalc = line.InCustCalc === 'Y';
                    }
                });
            });
        }
    };

    render () {
        const { render } = this.props;
        let content = '';
        switch(render) {
            case 'header':
                content = this.renderHeader();
                break;
            case 'body':
                content = this.renderBody();
                break;
            case 'footer':
                content = this.renderFooter();
                break;
            default:
                content = '';
        }

        return(
            <div className='Content'>
                {content}
            </div>
        );
    }
}

export { ContentLandedCosts };